import React, { useState } from "react";
import { Input, Button } from "antd";
import { Link } from "react-router-dom";
import { BASE_IMG, AUTHS_ALLOWED } from "../../constants";

export default function LoginBox({
    handleLogin,
    showForgotPassword = false,
  }) {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState('password');

    //  show and hide password
    const handleShowPassword = () => {
      setShowPassword(showPassword === 'password' ? 'text' : 'password');
    };

    const hasSSOAuth = AUTHS_ALLOWED.some(method => ['google', 'microsoft', 'linkedin'].includes(method));
    const hasLocalAuth = AUTHS_ALLOWED.includes('local');
    const canSubmitLocalAuth = Boolean(username && password);

    const handleLocalLogin = (event) => {
      event.preventDefault();
      handleLogin(event, "local", username, password);
    };

    return (
      <div className="login-box-container">
        <div className="login-box-text">Login</div>
        {hasSSOAuth && (
          <div className='login-social-container'>
            <div className='login-text-option'>
                <span>Using</span>
                <div className='login-option'>
                    {AUTHS_ALLOWED.includes('google') && (
                      <Button className="login-sso-container" onClick={(e) => handleLogin(e, 'google', '', '')}>
                          <img src={`${BASE_IMG}/icons8_google.svg`} alt="Google" />
                          <div className="login-sso-text">Google</div>
                      </Button>
                    )}
                    {AUTHS_ALLOWED.includes('microsoft') && (
                      <Button className="login-sso-container2" onClick={(e) => handleLogin(e, 'microsoft', '', '')}>
                          <img src={`${BASE_IMG}/microsoft 1.svg`} alt="Microsoft" />
                      </Button>
                    )}
                    {AUTHS_ALLOWED.includes('linkedin') && (
                      <Button className="login-sso-container3" onClick={(e) => handleLogin(e, 'linkedin', '', '')}>
                          <img src={`${BASE_IMG}/linkedin 1.svg`} alt="LinkedIn" />
                      </Button>
                    )}
                </div>
            </div>
            {hasSSOAuth && hasLocalAuth && (
              <div className='login-hr-tag'>
                  <div><hr className='hr' /><span>or</span><hr className='hr' /></div>
                  <span>Continue with email</span>
              </div>
            )}
          </div>
        )}
        {hasLocalAuth && (
          <form className="auth-form" onSubmit={handleLocalLogin}>
            <div className="login-box-input-container">
              <Input
                className="login-box-input-container2"
                id="username"
                type="email"
                autoComplete="email"
                value={username}
                placeholder="Email"
                onChange={(e) => setUsername(e.target.value)}
              />
              <Input className="login-box-input-container2" id="password" type={showPassword} value={password} placeholder="Password" onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                suffix={ showPassword === "password" 
                    ? <img src={`${BASE_IMG}/eye.svg`} alt="show-password" className="password-icon" onClick={handleShowPassword} /> 
                    : <img src={`${BASE_IMG}/cross_eye.svg`} alt="hide-password" className="password-icon" onClick={handleShowPassword}/>
                    }
              />
              {showForgotPassword && (
                <div className="login-forgot-action">
                  <Link to='/forgot-password'>New Password?</Link>
                </div>
              )}
            </div>
            <div className="login-box-button-container">
              <Button
                className="login-box-button-container-button"
                htmlType="submit"
                disabled={!canSubmitLocalAuth}
              >
                <div className="login-box-button-container-button-text">Login</div>
              </Button>
              {/* <div className="login-box-button-container-link">
                <a className="login-box-button-container-link-text">Forgot Password?</a>
              </div> */}
            </div>
          </form>
        )}
        {hasLocalAuth && (
          <div className="login-bottom-text-container">
              <p className="login-bottom-text-container-middle"><Link to='/register'>Sign up</Link>{" "}if you don't have a login or password yet.</p>
          </div>
        )}
      </div>
    );
  }